import request from '@/_util/require';
let version = 'v1';

// 标签管理---------------------------------
// 分页查询标签
export async function getTaskTagPage(options) {
  return request(`/${version}/waper/erp/pc/tasktag/gettasktagpage`, {
    method: 'POST',
    data: options,
  });
}
// 新增标签
export async function addTaskTag(options) {
  return request(`/${version}/waper/erp/pc/tasktag/addtasktag`, {
    method: 'POST',
    data: options,
  });
}
// 修改标签
export async function updateTaskTag(options) {
  return request(`/${version}/waper/erp/pc/tasktag/updatetasktag`, {
    method: 'POST',
    data: options,
  });
}
// 删除标签 (Assuming endpoint based on pattern, as user didn't specify but asked for delete op)
export async function deleteTaskTag(params) {
  return request(`/${version}/waper/erp/pc/tasktag/deletetasktag`, {
    method: 'GET',
    params,
  });
}
